interface GetStatementSelectionIdInput {
    userId: string;
    entityId: string;
    prefix: string;
}

/**
 * Get an id that can be used to get access to a statement selection state machine.
 * @param input - see {@link GetStatementSelectionIdInput}
 * @param entityId
 */
export const getStatementSelectionId = ({
    userId,
    entityId,
    prefix,
}: GetStatementSelectionIdInput): string =>
    `${prefix}user:${userId}.entity:${entityId}`;
